module.exports = __webpack_public_path__ + "static/media/country_sj.b29bd947.webp";